// extracted by mini-css-extract-plugin
export var container = "blogList-module--container--z+fd2";
export var flex_container = "blogList-module--flex_container--aLVfd";